<script setup>
  import { computed, inject } from 'vue'
  import { Wifi } from '@vicons/fa'
  import { NIcon, NPopover } from 'naive-ui'

  const appStoreFn = inject('appStoreFn')
  const appStore = appStoreFn()
  const networkTitle = computed(() => `Network Connection ${appStore.online ? 'Active' : 'Lost'}`)
  const networkIconColor = computed(() => (appStore.online ? 'green' : 'red'))
</script>
<template>
  <NPopover trigger="hover">
    <template #trigger>
      <NIcon :color="networkIconColor"><Wifi /></NIcon>
    </template>
    <span>
      <NIcon><Wifi :color="networkIconColor" /></NIcon>
      {{ networkTitle }}
    </span>
  </NPopover>
</template>
